<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} thông báo
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.validForm"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tiêu đề">
                      <el-input v-model="mData.tableRules.dataSearch.value.title" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngày tạo" prop="createdTime">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.createdTime"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="5">
                    <el-form-item label="Thời điểm hết hạn" prop="expiredTime">
                      <el-date-picker
                        type="daterange"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.expiredTime"
                        :placeholder="aElement.datepicker.placeholderDate"
                        range-separator="-"
                        start-placeholder="Từ ngày"
                        end-placeholder="đến ngày"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="6">
              <el-select
                v-model="mData.tableRules.dataSearch.value.type"
                :placeholder="'Loại thông báo'"
                @change="fn_tableSearch()"
                clearable
                filterable
              >
                <el-option
                  v-for="item in mData.dataDefault.typeNotifi"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="type"
            :sortable="mData.tableRules.allowSorting"
            label="Loại thông báo"
            min-width="200"
            align
            :formatter="fn_formatterType"
          ></el-table-column>
          <el-table-column prop="title" label="Tiêu đề" min-width="200"></el-table-column>
          <el-table-column prop="intro" label="Nội dung thông báo" width="200"></el-table-column>
          <!-- <el-table-column
            prop="from"
            :sortable="mData.tableRules.allowSorting"
            label="Người gửi"
            width="150"
          ></el-table-column>-->
          <el-table-column
            prop="createdTime"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm tạo"
            width="150"
            :formatter="fn_formatterDatetime"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="expiredTime"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm hết hạn"
            width="150"
            :formatter="fn_formatterDatetime"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
              prop="isRead"
              :sortable="mData.tableRules.allowSorting"
              label="Đã đọc"
              width="100"
          ></el-table-column>-->

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                v-if="aRole('Admin,Officer,TourAgent')"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer,TourAgent')"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ThongBaoModel from "./ThongBaoModel";
import ThongBaoApi from "../../../moduleApi/ThongBaoApi";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
// import NgoaiNguApi from "../../../moduleApi/NgoaiNguApi";

export default {
  data() {
    var validateTime = (rule, value, callback) => {
      let timeStart = this.mData.tableRules.dataSearch.value.createdTime;
      let timeEnd = this.mData.tableRules.dataSearch.value.expiredTime;

      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() > time2.getTime()) {
          callback(new Error(LanguageService.lang.valid_compareTimeThongBao));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      aLang: LanguageService.lang,
      aRole: MethodService.checkRole,
      aElement: MethodService.element,
      mData: {
        moduleName: "ThongBao", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(ThongBaoModel.tableRules),
        expiredTime: null,
        validForm: {
          expiredTime: { validator: validateTime, trigger: "blur" }
        },
        dataDefault: {
          roles: DataService.roles,
          listNgonNgu: DataService.Languages,
          typeNotifi: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await ThongBaoApi.listLogs(dataFilter);
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
      // MethodService.stopLadda();
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await ThongBaoApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await ThongBaoApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.title){
        this.mData.tableRules.dataSearch.value.title = this.mData.tableRules.dataSearch.value.title.trim();
      }
      
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let stringFilterAdd = "";
          if (this.mData.expiredTime && this.mData.expiredTime.length > 0) {
            stringFilterAdd =
              "expiredTime>=" +
              this.mData.expiredTime[0] +
              (this.mData.expiredTime[1] ||
              this.mData.tableRules.dataSearch.value.title ||
              this.mData.tableRules.dataSearch.value.createdTime
                ? "&"
                : "");
            if (this.mData.expiredTime[1]) {
              stringFilterAdd +=
                "expiredTime<=" +
                MethodService.addDate(this.mData.expiredTime[1], "days", 1) +
                (this.mData.tableRules.dataSearch.value.title ||
                this.mData.tableRules.dataSearch.value.createdTime
                  ? "&"
                  : "");
            }
          }
          console.log(stringFilterAdd);

          this.mData.tableRules.filters =
            stringFilterAdd +
            MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );

          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterType(row, column, cellValue, index) {
      let itemResult = ThongBaoModel.typeNotifiType.find(item => {
        return item.code == cellValue;
      });
      if (itemResult) {
        return itemResult.name;
      } else {
        return "";
      }
    },

    async fn_initDataDefault() {
      if (MethodService.checkRole("Admin,Officer")) {
        this.mData.dataDefault.typeNotifi =
          ThongBaoModel.typeNotifiAdminOfficer;
      }
      if (MethodService.checkRole("TourAgent")) {
        this.mData.dataDefault.typeNotifi = ThongBaoModel.typeNotifiTourAgent;
      }
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        let stringFilter = this.$route.query.filters;
        let regex = /(expiredTime[><]=(\d){4}-(\d){2}-(\d){2}T(\d){2}:(\d){2}:(\d){2})/g;
        let stringExpiredTime = stringFilter.match(regex);
        let expiredTimeCache = [];
        if (stringExpiredTime && stringExpiredTime.length > 0) {
          stringExpiredTime.forEach((item, index) => {
            if (index != 1) {
              stringFilter = stringFilter.replace(item + "&", "");
              expiredTimeCache.push(item.replace("expiredTime>=", ""));
            } else {
              stringFilter = stringFilter.replace(item + "&", "");
              expiredTimeCache.push(
                MethodService.addDate(
                  item.replace("expiredTime<=", ""),
                  "days",
                  -1
                )
              );
            }
          });
        }
        this.mData.expiredTime = expiredTimeCache;

        // string to object
        if (stringFilter) {
          this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
            stringFilter
          );
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>

<style scoped>
::v-deep .el-date-editor .el-range-separator {
  width: unset !important;
}
</style>
